import { apiCall } from "./index";

export const getDepartments = (page = 1, limit = 10) =>
  apiCall(`/departments?page=${page}&limit=${limit}`);

export const getDepartmentById = (departmentId) =>
  apiCall(`/departments/${departmentId}`);

export const createDepartment = (departmentData) =>
  apiCall(`/departments`, "POST", departmentData);

export const updateDepartment = (departmentId, departmentData) =>
  apiCall(`/departments/${departmentId}`, "PUT", departmentData);

export const deleteDepartment = (departmentId) =>
  apiCall(`/departments/${departmentId}`, "DELETE");
